import { CmsApiTileGridBlockData } from 'modules/cms/api/types/CmsApiTileGrid';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpTileGridBlock } from './CmsAmpTileGridBlock';
import { CmsTileGridBlock } from './CmsTileGridBlock';

export const CmsTileGridBlockMapping: CmsBlockMapping<CmsApiTileGridBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsTileGridBlock,
    AmpComponent: CmsAmpTileGridBlock,
  };
